<template lang="pug">
  #app(:class="[(this.$i18n.locale === 'ja') ? 'ja' : 'en' ]")
    .warnIE(v-if="$isIE")
      template(v-if="this.$i18n.locale === 'en'") This site is not compatible with Internet Explorer. Please click <a href="microsoft-edge:https://go.andwell.jp">here</a> to change your browser to Microsoft Edge.
      template(v-else) このサイトはInternet Explorerには対応しておりません。<a href="microsoft-edge:https://go.andwell.jp">こちら</a>からブラウザをMicrosoft Edgeに変更してください。
    modal(name="locale-select" :width="640" :height="375" :adaptive="true" :reset="true")
      LocaleSelect
    CommonHeader
    //-
      main
        .maintenance ただいまメンテナンス中です。<br>しばらくしてから再度アクセスしてください。
    main
      router-view(v-if="!needsSignin")
      div(v-else class="message")
        | ログインが必要なコンテンツです。
        span(@click="verifyBeforeSignin") こちら
        |からログインしてください。
    CommonFooter
</template>
<script>
import Vue from 'vue'
import VModal from 'vue-js-modal'
import CommonHeader from '@/components/CommonHeader'
import CommonFooter from '@/components/CommonFooter'
import LocaleSelect from '@/components/LocaleSelect'
import mixinUser from '@/mixins/user.js'
const { META } = require('@/assets/constants.json')

Vue.use(VModal)

export default {
  components: {
    CommonHeader,
    CommonFooter,
    LocaleSelect,
  },
  mixins: [mixinUser],
  computed: {
    needsSignin() {
      return (
        this.$route.meta.requiresAuth && !this.$store.state.user.authenticated
      )
    },
  },
  watch: {
    $route(routeInstance, from) {
      this.createMetaArea(routeInstance)
    },
    // SSGページのCSS表示切替(html[data-lang])を言語変更に追従させる
    '$i18n.locale'(locale) {
      this.applyLangAttribute(locale)
    },
  },
  created() {
    // 明示的に選択・保存された言語があればそれを優先。
    // 無ければブラウザ言語で判定（デフォルト日本語、日本語以外は英語）。
    // 自動判定結果は永続化しない（次回もブラウザ言語で再判定させるため）。
    this.$store.dispatch('loadLocale')
    const saved = this.$store.state.locale
    let lang
    if (saved === 'ja' || saved === 'en') {
      lang = saved
    } else {
      const nav =
        (window.navigator.languages && window.navigator.languages[0]) ||
        window.navigator.language ||
        window.navigator.userLanguage ||
        window.navigator.browserLanguage ||
        'ja'
      lang = nav.substr(0, 2) === 'ja' ? 'ja' : 'en'
    }
    this.$i18n.locale = lang
    this.applyLangAttribute(lang)
    this.$store.dispatch('setLocale', lang) // メモリのみ更新（永続化しない）
  },
  methods: {
    // SSGページ用: html要素の data-lang を更新して表示言語を切り替える
    applyLangAttribute(locale) {
      const lang = locale === 'ja' ? 'ja' : 'en'
      document.documentElement.setAttribute('data-lang', lang)
    },
    createMetaArea(routeInstance) {
      // title/og:titleを設定
      if (routeInstance.meta.title) {
        const setTitle = routeInstance.meta.title + ' | ' + META.TITLE
        document.title = setTitle
        document
          .querySelector("meta[property='og:title']")
          .setAttribute('content', setTitle)
        document
          .querySelector("meta[property='twitter:title']")
          .setAttribute('content', setTitle)
      } else {
        document.title = META.TITLE
        document
          .querySelector("meta[property='og:title']")
          .setAttribute('content', META.TITLE)
        document
          .querySelector("meta[property='twitter:title']")
          .setAttribute('content', META.TITLE)
      }

      // description/og:descriptionを設定
      if (routeInstance.meta.desc) {
        const setDesc = routeInstance.meta.desc + ' | ' + META.TITLE
        document
          .querySelector("meta[name='description']")
          .setAttribute('content', setDesc)
        document
          .querySelector("meta[property='og:description']")
          .setAttribute('content', setDesc)
        document
          .querySelector("meta[property='twitter:description']")
          .setAttribute('content', setDesc)
      } else {
        document
          .querySelector("meta[name='description']")
          .setAttribute('content', META.DESCRIPTION)
        document
          .querySelector("meta[property='og:description']")
          .setAttribute('content', META.DESCRIPTION)
        document
          .querySelector("meta[property='twitter:description']")
          .setAttribute('content', META.DESCRIPTION)
      }
    },
  },
  mounted() {
    this.createMetaArea(this.$route)
  },
}
</script>

<style lang="scss" scoped>
.maintenance {
  text-align: center;
  margin: 80px;
}
.message {
  padding: 30vh 0;
  text-align: center;
}
span {
  color: $base-brand-color;
  text-decoration: underline;
  cursor: pointer;
}
.warnIE {
  padding: 10px 12px;
  text-align: center;
  font-size: 14px;
  background: #ebdda0;
  a {
    color: $tags-color-blue;
    text-decoration: underline;
  }
}
</style>
